/**
 * How many brands we have on the platform, rounded to a nice number we're comfortable disclosing for marketing purposes
 */
export const HOME_PAGE_MAKER_COUNT = 'HOME_PAGE_MAKER_COUNT';
